import {Column, ColumnDef} from '@tanstack/table-core';
import difference from 'lodash/difference';

import {ColumnDefMeta} from './types';

export function getCellText(value: any, columnDef?: ColumnDef<any, any>): string {
  const columnMetadata: ColumnDefMeta | null | undefined = columnDef?.meta;
  if (columnMetadata?.textTransform) {
    return columnMetadata.textTransform(value);
  }
  return String(value);
}

export function getSelectionParams(column: Column<any, any>) {
  const meta = column.columnDef.meta as ColumnDefMeta;
  return meta.columnSelectionParams;
}

export function sortColumnsBasedOnOrder(columns: Array<Column<any, any>>) {
  return columns
    .filter((column) => {
      const selectionParams = getSelectionParams(column);
      return selectionParams && typeof selectionParams.order === `number` && selectionParams?.isSelected;
    })
    .sort((a, b) => {
      const aOrder = getSelectionParams(a)?.order ?? 0;
      const bOrder = getSelectionParams(b)?.order ?? 0;
      return aOrder - bOrder;
    })
    .map((col) => col.id);
}

export function getUpdatedColumnOrder(visibleColumns: Array<Column<any, any>>, oldColumnOrder: string[]) {
  let newOrder = oldColumnOrder;
  let affectedColIds: string[] = [];
  if (visibleColumns.length > oldColumnOrder.length) {
    // column was added, add it to the end of the order
    const added = difference(
      visibleColumns.map((col) => col.id),
      oldColumnOrder,
    );
    newOrder = [...oldColumnOrder, ...added];
    affectedColIds = added;
  } else if (visibleColumns.length < oldColumnOrder.length) {
    // column was removed, remove it from the order
    const removed = difference(
      oldColumnOrder,
      visibleColumns.map((col) => col.id),
    );
    newOrder = oldColumnOrder.filter((col) => !removed.includes(col));
    affectedColIds = removed;
  }
  return {newOrder, affectedColIds};
}
